import { SurfedDirection, WaveWithInsights } from 'types/recordings';

export const GRAPH_BAR_WIDTH = 15; // 15 seconds

export const GRAPH_BAR_WIDTH_IN_MS = GRAPH_BAR_WIDTH * 1000; // 15 seconds

export type WaveGraphBar = WaveWithInsights | {};

export const combineSurfedDirections = (
  direction1: SurfedDirection,
  direction2: SurfedDirection,
) => {
  if (direction1 === direction2) return direction1;
  if (direction1 === SurfedDirection.NONE) return direction2;
  if (direction2 === SurfedDirection.NONE) return direction1;
  return SurfedDirection.BOTH;
};

export const combineWaves = (
  wave1: WaveWithInsights,
  wave2: WaveWithInsights,
): WaveWithInsights => {
  const combinedWave = { ...wave2 };

  combinedWave.surfedDirection = combineSurfedDirections(
    wave1.surfedDirection,
    wave2.surfedDirection,
  );

  combinedWave.height = Math.max(wave2.height, wave1.height);

  combinedWave.endTime =
    wave2.endTime || wave1.endTime
      ? new Date(
          Math.max(new Date(wave2.endTime || 0).getTime(), new Date(wave1.endTime || 0).getTime()),
        ).toISOString()
      : undefined;

  return combinedWave;
};

export const updateWaveGraphBarsWithNewRewind = (
  existingWaveGraphBars: WaveGraphBar[],
  wavesToAdd: WaveWithInsights[],
  bucketStartTime: number,
  shouldHideSurfedDirection: boolean,
): WaveGraphBar[] => {
  const updatedWaves = [...existingWaveGraphBars];

  wavesToAdd.forEach((wave) => {
    const waveTime = new Date(wave.startTime).getTime();
    const waveIndex = Math.floor((waveTime - bucketStartTime) / GRAPH_BAR_WIDTH_IN_MS);
    if (waveIndex < 0 || waveIndex >= updatedWaves.length) {
      return;
    }

    const existingWave = updatedWaves[waveIndex];

    const newWave = {
      ...wave,
      surfedDirection: shouldHideSurfedDirection ? SurfedDirection.NONE : wave.surfedDirection,
    };

    const combinedWave = 'height' in existingWave ? combineWaves(existingWave, newWave) : newWave;

    updatedWaves[waveIndex] = combinedWave;
  });
  return updatedWaves;
};

export const generateEmptyWaveGraphBars = (startTimestamp: number, endTimestamp: number) => {
  const lengthOfArray = (endTimestamp - startTimestamp) / GRAPH_BAR_WIDTH_IN_MS;
  return new Array(lengthOfArray).fill({});
};
